<template>
	<div class="laywerhot">
		<sec-title
		  ac-text="法律"
		  Text="热点"
		  desc-text="查知识学法律成为一名知法、懂法、用法的好公民。"
		  :showmore = 'false'
		/>
		<ul class="firstlist flex">
			<li v-for="(item , index) in 6" @click="clickbar(index)"
			:class="['FontSize20',theindex == index?'item-active':'']"
			>婚姻家庭</li>
		</ul>
		<div class="secondlist flex wrap between">
			<div class="seconditem " v-for="item in 9">
				<span class="FontSize20 FontBlack">刑事辩护</span>
				<ul class="lastlist flex FontGray1 FontSize16 wrap">
					<li v-for="item in 8">辩护权</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import secTitle from "../components/secTitle";
	export default{
		components:{secTitle},
		data(){
			return{
				theindex:0
			}
		},
		methods:{
			clickbar(index){
				this.theindex = index	
			}
		}
	}
</script>

<style lang="scss"scoped="scoped">
	.laywerhot{
		width: 1200px;
		margin: 0 auto;
		.firstlist{
			list-style: none;
			li{
				margin-right: 40px;
				cursor: pointer;
				color: #999999;
				margin-bottom: 35px;
			}
			.item-active{
				font-weight: bold;
				color: #333;
				border-bottom: 3px solid #0465EA;
			}
		}
		.secondlist{
			.seconditem{
				width: 30%;
				height: 140px;
				box-shadow: 5px 5px 5px #f7f7f7;
				margin-bottom: 20px;
			}
			.lastlist{
				margin-top: 20px;
				li{
					margin: 0 20px 20px 0;
				}
			}
		}
	}
</style>
